export const irWhatsApp = ({num, pais}) =>{
    let url = `https://api.whatsapp.com/send?phone=57${num}`
    if (pais !== 'Colombia'){
        url = `https://api.whatsapp.com/send?phone=593${num}`
    }

    window.open(url)

}